import { Breadcrumbs } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Breadcrumbs)`
  & .MuiBreadcrumbs-separator {
    font-size: 10px;
  }
`;
